const upload_type = 1;      // 上传类型【1=七牛云】【2=阿里云】

// const admin_api = 'http://xgc.api.xiaocx.my/Api';

// const admin_api = 'http://xgc.xiaocx.cc/Api';

const admin_api = 'https://api.xyxgc.com.cn/Api';

// 上传地址
const upload_url = admin_api + '/ali_oss/index';
export default {
    upload_type,
    upload_url,
    admin_api
}



// WEBPACK FOOTER //
// ./src/util/common.js